import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import chatState from '../state/chat';
import ChatDrawer from './ChatDrawer';
import { shouldUseChatDrawer } from '../utils/surface';
/**
 * "X tornou você moderador de #canal."
 *
 * Os dados guardados são só ids; o nome vem do subject, que a lista de
 * notificações carrega pelas regras de visibilidade do canal.
 */
export default class ModeratorPromotedNotification extends Notification {
  icon() {
    return 'fas fa-user-shield';
  }
  href() {
    const channelId = channelIdOf(this);
    return channelId ? app.route('chat.channel', {
      id: channelId
    }) : app.route('chat.index');
  }
  content() {
    return app.translator.trans('ramon-chat.forum.notifications.moderator_promoted', {
      username: fromName(this),
      channel: channelNameOf(this)
    });
  }
  excerpt() {
    return null;
  }
  onclick(e) {
    openChannelFromNotification(this, e);
  }
}

/** Id do canal, vindo dos dados ou do subject. */
export function channelIdOf(notification) {
  var _ref, _data$channelId;
  const data = (_ref = notification.attrs.notification.content()) != null ? _ref : {};
  const subject = notification.attrs.notification.subject();
  const id = (_data$channelId = data.channelId) != null ? _data$channelId : subject ? Number(subject.id()) : null;
  return id ? Number(id) : null;
}

/** Nome do canal como o leitor o vê, ou o título do chat. */
export function channelNameOf(notification) {
  var _subject$displayName;
  const subject = notification.attrs.notification.subject();
  return (subject == null || (_subject$displayName = subject.displayName) == null ? void 0 : _subject$displayName.call(subject)) || app.translator.trans('ramon-chat.forum.nav.chat', {}, true);
}

/** Quem enviou a notificação, ou "Alguém". */
export function fromName(notification) {
  const user = notification.attrs.notification.fromUser();
  return user ? user.displayName() : app.translator.trans('ramon-chat.forum.notifications.someone', {}, true);
}

/**
 * Abre o drawer em vez de seguir o href quando essa é a preferência do leitor,
 * igual ao botão do cabeçalho.
 */
export function openChannelFromNotification(notification, e) {
  const channelId = channelIdOf(notification);
  if (!channelId || !shouldUseChatDrawer()) return;
  e.preventDefault();
  chatState.setActiveChannel(channelId);
  ChatDrawer.open();
}
flarum.reg.add('ramon-chat', 'forum/components/ModeratorPromotedNotification', ModeratorPromotedNotification);